import { render, staticRenderFns } from "./DisplaySummary.vue?vue&type=template&id=8280d4b2"
import script from "./DisplaySummary.vue?vue&type=script&lang=js"
export * from "./DisplaySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports